type FlatMapCallback<T, R> = {
  (arg: T, index: number, arr: T[]): R | readonly R[]
}

type FlatMap = {
  <T, R>(f: FlatMapCallback<T, R>, arr: T[]): R[]
  <T, R>(f: FlatMapCallback<T, R>): (arr: T[]) => R[]
}

// @ts-expect-error не выдерживает перегрузку
export const flatMap: FlatMap = <T, R>(f: FlatMapCallback<T, R>, arr?: T[]) => {
  const curried = (a: T[]): R[] => {
    if (typeof Array.prototype.flatMap === 'function') {
      return a.flatMap(f)
    }

    const result: R[] = []
    for (const [i, el] of a.entries()) {
      const elementArr = f(el, i, a)
      if (Array.isArray(elementArr)) {
        for (const resultEl of elementArr) {
          result.push(resultEl)
        }
      } else {
        result.push(elementArr as R)
      }
    }

    return result
  }

  if (arr === undefined) return curried
  else return curried(arr)
}
